<template>
    <div class="dd-m-auth dd-m-auth--recovery">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Recover your<br/>password—</h2>

            <div class="dd-m-auth__form">
                <form class="dd-m-form dd-m-form--recovery dd-m-form--auth"
                      v-on:submit.prevent="send">
                    <div class="dd-m-form--auth__description">
                        Insira abaixo o email cadastrado. Enviaremos uma mensagem com instruções de como recuperar sua
                        password.
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col">
                            <div class="dd-m-form__icon-input">
                                <input type="email"
                                       name="email"
                                       placeholder="E-mail"
                                       required
                                       v-model="email.value"
                                       class="dd-m-form__input dd-m-form__input--bordered">
                                <vue-ladda :loading="loading"
                                           button-class="dd-m-button dd-m-button--assertive dd-m-button--tiny dd-m-helper--centralize"
                                           data-style="zoom-in">
                                    <i class="dd-m-icon icon-send"></i>
                                </vue-ladda>
                            </div>

                            <div class="dd-m-form__error-msg dd-m-form__error-msg--normal dd-show"
                                 v-if="email.errors.length">
                                {{email.errors[0]}}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'auth-recovery',
        data: () => {
            return {
                loading: false,
                email: {
                    value: null,
                    errors: []
                }
            }
        },
        mounted() {
        },
        methods: {
            send() {
                this.email.errors = [];

                if (this.email.value) {
                    this.loading = true;
                    const data = {email: this.email.value};
                    axios.post(`/api/request/reset/password`, data)
                        .then(() => {
                            this.loading = false;
                            PubSub.publish('updateRecoveryStep', {step: 2, email: this.email.value});
                        })
                        .catch((err) => {
                            this.email.errors = err.response.data.error ? [err.response.data.error.message] :
                                [err.response.data.message];

                            this.loading = false;
                        });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-recovery.vue